import * as Yup from 'yup';
import {
  findOverlappingDeliverySlots,
  hasLowercaseMeridiem,
  parseDeliveryTimeSlotsValue,
} from '../pages/Settings/DeliveryTimeSlotsEditor';

const settingSchema = Yup.object().shape({
  name: Yup.string().required('Name is required.'),
  value: Yup.string().when('name', {
    is: 'cod_active',
    then: Yup.string().notRequired(),
    otherwise: Yup.string()
      .required('Value is required.')
      .test(
        'delivery-slots-uppercase-meridiem',
        'Use AM/PM in uppercase (e.g. "2 PM to 6 PM"), not am/pm.',
        function (value) {
          if (this.parent?.name !== 'delivery_time_slots') {
            return true;
          }
          const rows = parseDeliveryTimeSlotsValue(String(value || ''));
          return !rows.some((row) => {
            if (!row.startTime || !row.endTime) return false;
            return hasLowercaseMeridiem(`${row.startTime} to ${row.endTime}`);
          });
        }
      )
      .test(
        'delivery-slots-no-overlap',
        'Delivery slots overlap. Adjust the times so they do not overlap.',
        function (value) {
          if (this.parent?.name !== 'delivery_time_slots') {
            return true;
          }
          const rows = parseDeliveryTimeSlotsValue(String(value || ''));
          const slots = rows
            .map((row) => {
              if (!row.startTime || !row.endTime) return null;
              return { slot: `${row.startTime} to ${row.endTime}` };
            })
            .filter(Boolean) as Array<{ slot: string }>;
          return !findOverlappingDeliverySlots(slots);
        }
      ),
  }),
  valueType: Yup.string().when('name', {
    is: 'cod_active',
    then: Yup.string().notRequired(),
    otherwise: Yup.string().required('Type is required.'),
  }),
  language: Yup.string().when('name', {
    is: 'cod_active',
    then: Yup.string().notRequired(),
    otherwise: Yup.string().required('Language is required.'),
  }),
});

export default settingSchema;